import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import PropertyFilesPanel from '@/components/PropertyFilesPanel';

/**
 * Modal wrapper around the reusable PropertyFilesPanel. Used from the
 * property card so managers/owners/staff can browse and upload files
 * without leaving the properties list.
 */
export const PropertyFilesDialog = ({ open, onOpenChange, property }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-2xl max-h-[90vh] overflow-y-auto"
        data-testid="property-files-dialog"
      >
        <DialogHeader>
          <DialogTitle>Files · {property?.name}</DialogTitle>
          <DialogDescription>
            House info, rules, Wi-Fi codes, cleaning notes, and any doc your
            team needs on-site. Everyone in the organization can upload;
            managers and owners can delete.
          </DialogDescription>
        </DialogHeader>
        {property?.id && <PropertyFilesPanel propertyId={property.id} />}
      </DialogContent>
    </Dialog>
  );
};

export default PropertyFilesDialog;
